import Main from './Main'
import { LayoutAll } from '../../Layout/CommonStyle'

function MenteeInvertory() {
  return (
    <LayoutAll>
      <Main />
    </LayoutAll>
  )
}

export default MenteeInvertory
